import { useEffect, useState, type ReactNode } from 'react'
import { getConfig } from '../api'
import { AppContext, useApp } from '../app-context'
import type { PublicConfig } from '../types'

// A homepage or dashboard tab may predate a pause. Refresh before mounting any
// purchase fields, while keeping authentication and existing order state intact.
export function PurchaseFlow({ children }: { children: ReactNode }) {
  const app = useApp()
  const [config, setConfig] = useState<PublicConfig | null>(null)
  const [error, setError] = useState(false)
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let active = true
    getConfig().then(value => { if (active) setConfig(value) }).catch(() => { if (active) setError(true) })
    return () => { active = false }
  }, [attempt])
  if (!config) return <div className="page page--narrow">
    <p role="status">{error ? 'Could not check purchase availability. Please try again.' : 'Checking purchase availability…'}</p>
    {error && <button className="button button--outline" onClick={() => { setError(false); setAttempt(value => value + 1) }}>Try again</button>}
  </div>
  return <AppContext.Provider value={{ ...app, config }}>{children}</AppContext.Provider>
}
